import { ReactNode } from "react";
import MDBox from "components/MDBox";

// Standard page body wrapper for list/detail pages. Replaces the ad-hoc
// `<MDBox px={2} pt={...}>` variations scattered across pages so every page has
// the same horizontal padding and top/bottom rhythm.
//
// Render it AFTER <DashboardNavbar/> inside a page:
//   <><DashboardNavbar .../><PageShell filters={<Filters/>}>{content}</PageShell></>
interface Props {
  children: ReactNode;
  /** Optional filter/toolbar row rendered above the content. */
  filters?: ReactNode;
  /** When a create/edit form is open, use slightly larger top padding. */
  openForm?: boolean;
  /** Flex-column mode (e.g. pr-management) so a child table can flex-grow. */
  flex?: boolean;
}

function PageShell({ children, filters, openForm = false, flex = false }: Props): JSX.Element {
  return (
    <MDBox
      px={2}
      pt={openForm ? 3 : 2}
      pb={3}
      sx={
        flex
          ? { display: "flex", flexDirection: "column", minHeight: "calc(100vh - 5rem)" }
          : undefined
      }
    >
      {filters}
      {children}
    </MDBox>
  );
}

export default PageShell;
